import { useEffect } from 'react';

export function useBodyClass(classes: string[]) {
  useEffect(() => {
    const body = document.body;
    classes.forEach((cls) => body.classList.add(cls));
    return () => {
      classes.forEach((cls) => body.classList.remove(cls));
    };
  }, [classes.join(' ')]);
}
